import { render, staticRenderFns } from "./License.vue?vue&type=template&id=f3c3fc8a&scoped=true&"
import script from "./License.vue?vue&type=script&lang=ts&"
export * from "./License.vue?vue&type=script&lang=ts&"
import style0 from "./License.vue?vue&type=style&index=0&id=f3c3fc8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c3fc8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
